import {NO_MAX_DATE_VALUE} from 'common/components/calendar/types';

import {DateRange} from './date-range';
import {DateRangeType} from './types';

export class ExperimentDateRange extends DateRange {
  public getDateRangeTypeOptions() {
    return [DateRangeType.Since];
  }

  public override getCalendarMaxDate(): string | null {
    return NO_MAX_DATE_VALUE;
  }
}

export class ExperimentCompletedDateRange extends DateRange {
  public getDateRangeTypeOptions() {
    return [DateRangeType.Between];
  }

  public override getCalendarMaxDate(): string | null {
    return NO_MAX_DATE_VALUE;
  }
}
